module.exports = __webpack_public_path__ + "static/media/03n.30ecfdcf.svg";